// Dati ufficiali Dea srl - modifica qui per aggiornare ovunque
export const COMPANY = {
  name: "Dea srl",
  founded: 2022,
  area: "Provincia di Pavia · Provincia di Milano",
  email: "info@deagarlasco.it",
  quotesEmail: "preventivi@deagarlasco.it",
  instagramHandle: "@deasrlgarlasco",
  instagramUrl: "https://www.instagram.com/deasrlgarlasco/",
  hours: "Lun – Ven · 08:00 – 18:00",
  vatNumber: "P.IVA da inserire",
  rea: "REA da inserire",
};

export const OWNERS = [
  {
    name: "Denny Chiaborelli",
    role: "Titolare",
    phone: "+39 339 301 5941",
    phoneClean: "393393015941", // formato wa.me (no +)
    phoneHref: "+393393015941",
  },
  {
    name: "Alex Casagrande",
    role: "Titolare",
    phone: "+39 349 678 0280",
    phoneClean: "393496780280",
    phoneHref: "+393496780280",
  },
];

// Numero principale per WhatsApp/preventivi (Denny)
export const PRIMARY_CONTACT = OWNERS[0];

// Messaggio precompilato WhatsApp (questionario per scremare lead)
export function buildWhatsAppMessage({ servizio = "", citta = "" } = {}) {
  const lines = [
    "Ciao Dea srl, vorrei richiedere un preventivo.",
    "",
    "▸ Nome e cognome: ",
    "▸ Tipo di lavoro: " + (servizio || "(facciate / cappotto / finiture / ristrutturazione / carpenteria)"),
    "▸ Indirizzo dell'intervento: " + citta,
    "▸ Superficie indicativa (mq): ",
    "▸ Tempistiche desiderate: (urgente / 1-3 mesi / 3-6 mesi / da valutare)",
    "▸ Breve descrizione del lavoro: ",
    "",
    "Grazie!",
  ];
  return lines.join("\n");
}

export function buildWhatsAppUrl(message, phone = PRIMARY_CONTACT.phoneClean) {
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}
